import React, { PropsWithChildren, useMemo } from 'react';

import type { CustomizationProviderProps } from '@twilio-paste/core/customization';
import { CustomizationProvider } from '@twilio-paste/core/customization';

const theme: CustomizationProviderProps['theme'] = {
  shadows: {
    shadowFocus: 0,
    shadowFocusShadowBorder: 0,
    shadowFocusInset: 0,
  },
};

const customElements: CustomizationProviderProps['elements'] = {
  MODAL_BODY: {
    fontSize: 'fontSize40',
  },
  SIDE_MODAL_HEADER_CLOSE_BUTTON: {
    display: 'flex',
  },
};

export interface ThemeProviderProps
  extends PropsWithChildren,
    Pick<CustomizationProviderProps, 'elements' | 'disableAnimations' | 'baseTheme'> {
  root?: boolean;
}

export const ThemeProvider = ({
  children,
  disableAnimations,
  elements,
  baseTheme = 'default',
}: ThemeProviderProps) => {
  const themeElements = useMemo(
    () => ({
      ...customElements,
      ...elements,
    }),
    [elements],
  );

  const provider = (
    <CustomizationProvider
      baseTheme={baseTheme}
      disableAnimations={disableAnimations}
      elements={themeElements}
      theme={theme}
    >
      {children}
    </CustomizationProvider>
  );

  return provider;
};
